/**
 * Set in the application's docker files.
 */
export enum AppEnvironment {
  Development = 'development',
  Test = 'test',
  Production = 'production',
}
